import i18n from "../i18n";

export const setAuth = (token: string, userId: string): void => {
  localStorage.setItem('userToken', token);
  localStorage.setItem('userId', userId);
};

export const getToken = (): string | null => {
  return localStorage.getItem('userToken');
};

export const getUserId = (): string | null => {
  return localStorage.getItem('userId');
};

export const clearAuth = (): void => {
  localStorage.removeItem('userToken');
  localStorage.removeItem('userId');
  localStorage.removeItem('currentShopId');
  localStorage.removeItem('currentShop');
  localStorage.removeItem('shopList');
};

// 获取请求头所需的认证信息
export const getAuthHeaders = (): Record<string, string> => {
  const token = getToken();
  const currentLang = i18n.language.toLowerCase().startsWith('zh') ? 'CN' : 'EN';
  
  return {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'userToken': token || '',
    'x-auth-token': token || '',
    'language': currentLang,
    'languagetype': currentLang,
    // 其他必要的头信息
    'anonymoususeruuid': '',
    'cityid': '',
    'lat': '',
    'lon': '',
  };
};

export const hasRequiredLoginData = (): boolean => {
  return !!getToken() && !!getUserId();
}; 